import { useEffect, useState } from 'react';

export const useIntercom = () => {
  const [, setShowIntercom] = useState(false);

  useEffect(() => {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    (window as any).Intercom('onShow', function () {
      setShowIntercom(true);
    });

    /* eslint-disable @typescript-eslint/no-explicit-any */
    (window as any).Intercom('onHide', function () {
      setShowIntercom(false);
    });
  }, []);

  const handleShowIntercom = () => {
    setShowIntercom((prev) => {
      const nextState = !prev;

      if (nextState == true) {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        (window as any).Intercom('show');
        return nextState;
      }

      /* eslint-disable @typescript-eslint/no-explicit-any */
      (window as any).Intercom('hide');

      return nextState;
    });
  };

  return { handleShowIntercom };
};
